import React from 'react';
import { useContext } from 'react';
import { makeStyles, Theme, createStyles, Typography, Button, Box } from '@material-ui/core';
import CustomDialog from './CustomDialog';
import { LocalizationContext } from './LanguageContext/LocalizationContext';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            color: theme.palette.text.primary,
            fontSize: theme.typography.pxToRem(24),
            fontWeight: 'bold',
            marginBottom: theme.spacing(2),
            textAlign: 'center',
        },
        message: {
            color: theme.palette.text.primary,
            fontSize: theme.typography.pxToRem(16),
            lineHeight: 1.5,
            marginBottom: theme.spacing(3),
            textAlign: 'center',
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: theme.spacing(2),
        },
        button: {
            minWidth: '120px',
        },
    })
);

interface SsnMismatchPopupProps {
    open: boolean,
    onClose: () => void
}

const SsnMismatchPopup: React.FC<SsnMismatchPopupProps> = ({ open, onClose }) => {
    const classes = useStyles();
    const { translation } = useContext(LocalizationContext);

    return (
        <CustomDialog
            open={open}
            handleClose={onClose}
            header=""
            maxWidth="sm"
        >
            <Box>
                <Typography className={classes.title}>
                    {translation.ssnMismatchTitle}
                </Typography>
                <Typography className={classes.message}>
                    {translation.ssnMismatchMessage}
                </Typography>
                <Box className={classes.buttonContainer}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onClose}
                        className={classes.button}
                    >
                        {translation.ssnMismatchOkButton}
                    </Button>
                </Box>
            </Box>
        </CustomDialog>
    );
};

export default SsnMismatchPopup;